"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Chip = _interopRequireDefault(require("../Chip/Chip"));

/* eslint-disable no-plusplus */

/* eslint-disable react/jsx-props-no-spreading */
var ChipWrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "SelectedList__ChipWrapper",
  componentId: "sc-13xw7qj-0"
})(["overflow-x:auto;overflow-y:hidden;"]);
var CHIP_WIDTH = 120;
var BUFFER = 20; // SelectedList is also a virtual list. See ./Dropdown for more info.

var VirtualList = function VirtualList(_ref) {
  var values = _ref.values,
      selected = _ref.selected,
      active = _ref.active,
      inactive = _ref.inactive,
      handleChipClick = _ref.handleChipClick;

  var _useState = (0, _react.useState)(0),
      scrollLeft = _useState[0],
      setScrollLeft = _useState[1];

  var _useState2 = (0, _react.useState)(0),
      containerWidth = _useState2[0],
      setContainerWidth = _useState2[1];

  var containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var current = containerRef.current;

    if (current) {
      setContainerWidth(current.clientWidth);
    }
  }, []);
  var innerWidth = Math.ceil(selected.length) * CHIP_WIDTH;
  var startIndex = Math.max(Math.floor(scrollLeft / CHIP_WIDTH) - BUFFER, // buffer of 20 chips
  0 // don't render past the beginning of the list
  );
  var endIndex = Math.min(selected.length - 1, // don't render past the end of the list
  Math.floor((scrollLeft + containerWidth) / CHIP_WIDTH) + BUFFER // buffer of 20 rows
  );

  var handleScroll = function handleScroll(e) {
    return setScrollLeft(e.target.scrollLeft);
  };

  var chips = [];

  var _loop = function _loop(i) {
    var _values$find;

    var selectedId = selected[i];
    chips.push(_react["default"].createElement(_Chip["default"], {
      key: selectedId,
      width: CHIP_WIDTH,
      hideOverFlow: true,
      mr: 2,
      my: 0,
      isActive: true,
      trailingIcon: "close",
      onClick: handleChipClick(selectedId),
      palette: {
        active: active,
        inactive: inactive
      }
    }, (_values$find = values.find(function (value) {
      return value.id === selectedId;
    })) == null ? void 0 : _values$find.name));
  };

  for (var i = startIndex; i <= endIndex; i++) {
    _loop(i);
  }

  return _react["default"].createElement(ChipWrapper, {
    onScroll: handleScroll,
    ref: containerRef
  }, _react["default"].createElement(_Flex["default"], {
    flexWrap: "nowrap",
    width: innerWidth,
    pl: startIndex * CHIP_WIDTH
  }, selected && chips));
};

var SelectedList = function SelectedList(_ref2) {
  var values = _ref2.values,
      selected = _ref2.selected,
      active = _ref2.active,
      inactive = _ref2.inactive,
      wrapSelection = _ref2.wrapSelection,
      toggleSelection = _ref2.toggleSelection;

  var handleChipClick = function handleChipClick(id) {
    return function (e) {
      e.stopPropagation();
      toggleSelection(id);
    };
  };

  if (!wrapSelection) return _react["default"].createElement(VirtualList, {
    values: values,
    selected: selected,
    active: active,
    inactive: inactive,
    handleChipClick: handleChipClick
  });
  return _react["default"].createElement(ChipWrapper, {
    flexWrap: "wrap"
  }, selected == null ? void 0 : selected.map(function (selectedId) {
    var _values$find2;

    return _react["default"].createElement(_Chip["default"], {
      key: selectedId,
      mr: 2,
      my: 1,
      isActive: true,
      trailingIcon: "close",
      onClick: handleChipClick(selectedId),
      palette: {
        active: active,
        inactive: inactive
      }
    }, (_values$find2 = values.find(function (value) {
      return value.id === selectedId;
    })) == null ? void 0 : _values$find2.name);
  }));
};

var _default = SelectedList;
exports["default"] = _default;